import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth/store'
import flashMessage from './partials/flash-message/store'
import booking from './modules/booking/store'
import flights from './modules/booking/flights/store'
import spinner from './partials/spinner/store'
import allBookings from './modules/all-bookings/store'
import profile from './modules/profile/store'
import baggage from './modules/menu-bar/essential-info/baggage/store'
import faq from './modules/booking/faq/store'
import contactUs from './partials/contact-us/store'
import essentialInfoMenu from './modules/menu-bar/essential-info/store'
import account from './modules/navigation/modals/payment-hub/make-payment/store'
import corporate from './modules/corporate/store'
import friendFamily from './modules/booking/friendfamily/store'
import weddingAbroad from './modules/booking/weddingabroad/store'
import tours from './modules/booking/tours/store'
import staff from './modules/staffarea/store'
import navigation from './modules/navigation/store'
import communications from './modules/navigation/communications/store'

Vue.use(Vuex)

const store = new Vuex.Store({
  getters: {
    getInternal(state) {
      return state.isInternal
    },
  },
  mutations: {
    setInternal(state, value) {
      state.isInternal = value
    },
  },
  actions: {
    updateInternal({ commit }, value) {
      commit('setInternal', value)
    },
    // The main loader action, loaded on app init
    async initAppAction({ dispatch, commit }, loadBookingData) {
      const res = await dispatch('booking/loadBookingAction', loadBookingData, {
        root: true,
      })
      if (res) {
        // commit auth data before the dependent dispatches below - several of them
        // (e.g. flights/loadFlightsAction) read rootState.auth.userData and must not
        // run against a stale/empty auth state
        commit('auth/loginBookingNumberSuccess', loadBookingData, {
          root: true,
        })
        dispatch('flights/loadFlightsAction', null, { root: true })
        dispatch('baggage/loadBaggageAction', null, { root: true })
        dispatch('account/loadReceiptsAction', null, { root: true })
        dispatch('tours/loadAllLocalTours', null, { root: true })
        dispatch('auth/loadAllLoginOptionsAction', null, { root: true })
        dispatch('communications/setEtrailsAction', loadBookingData.bookno, {
          root: true,
        })
        dispatch('communications/setEtrailCategoriesAction', null, {
          root: true,
        })
      }
      return res
    },
    resetStores({ dispatch }) {
      const modules = store._modules.root._children
      if (modules) {
        Object.keys(modules).forEach((module) => {
          if (modules[module]._rawModule.actions.resetStateAction) {
            dispatch(`${module}/resetStateAction`, null, { root: true })
          }
        })
      }
    },
  },

  modules: {
    auth,
    flashMessage,
    booking,
    spinner,
    allBookings,
    profile,
    flights,
    baggage,
    faq,
    contactUs,
    essentialInfoMenu,
    account,
    friendFamily,
    weddingAbroad,
    corporate,
    tours,
    staff,
    navigation,
    communications,
  },
})

export default store
